module.exports = __webpack_public_path__ + "img/prizeDetailBanner.56287bfb.png";